import metadataApi from "../../api/metadataApi";

const state = { metadatas: [], errors: [], options: [], metadataOptions:[] };

const actions = {
  createMetadata({ commit }, metadata) {
    return new Promise((resolve, reject) => {
      metadataApi.store(metadata)
        .then((response) => {
          if (response.status === 201) {
            commit("ADD_METADATA", response.data.metadata);
            resolve(response);
          }
          reject(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getMetadata({ commit }) {
    return new Promise((resolve, reject) => {
      metadataApi
        .all()
        .then((response) => {
          if (response.status === 200) {
            commit("SET_METADATA", response.data);
            resolve(response);
          }
          reject(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  updateMetadata({ commit }, data) {
    return new Promise((resolve, reject) => {
      metadataApi
        .update(data)
        .then((response) => {
          if (response.status === 200) {
            commit("UPDATE_METADATA", response.data.metadata);
            resolve(response);
          }
          reject(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  deleteMetadata({ commit }, metadataId) {
    return new Promise((resolve, reject) => {
      metadataApi
        .delete(metadataId)
        .then((response) => {
          if (response.status === 200) {
            commit("DELETE_METADATA", metadataId);
            resolve(response);
          }
          reject(response);
        })
        .catch((error) => {
          reject(error);

        });
    });
  },

  addOption({ commit }, option) {
    return new Promise((resolve, reject) => {
      metadataApi.storeOption(option)
      .then((response) => {
        if (response.status === 201) {
          commit('ADD_OPTION', response.data.option);
          resolve(response);
        }
        reject(response)
      })
      .catch((error) => {
        reject(error);
      })
    })
  },

  getOptions({ commit }) {
    return new Promise((resolve, reject) => {
      metadataApi.allOptions()
      .then((response) => {
        if (response.status === 200) {
          commit('SET_OPTIONS', response.data);
          resolve(response);
        }
        reject(response)
      })
      .catch((error) => {
        reject(error);
      })
    })
  },

  getMetadataOptions({ commit }, metadataId) {
    return new Promise((resolve, reject) => {
      metadataApi.metadataOptions(metadataId)
      .then((response) => {
        if (response.status === 200) {
          commit("SET_METADATA_OPTIONS", response.data);
          resolve(response);
        }
        reject(response);
      })
      .catch((err) => {
        reject(err);
      })
    })
  }

};

const mutations = {
  ADD_METADATA: (state, metadata) => state.metadatas.unshift(metadata),
  SET_METADATA: (state, metadatas) => (state.metadatas = metadatas),
  ADD_OPTION: (state, option) => state.options.unshift(option),
  SET_OPTIONS: (state, options) => state.options = options,
  SET_METADATA_OPTIONS: (state, metadataOptions) => state.metadataOptions = metadataOptions,

  UPDATE_METADATA: (state, metadata) => {
    const index = state.metadatas.findIndex(
      (m) => m.id === metadata.id
    );

    if (index !== -1) {
      state.metadatas.splice(index, 1, metadata);
    }
  },

  DELETE_METADATA: (state, metadataID) => {
    state.metadatas = state.metadatas.filter(
      (metadata) => metadata.id !== metadataID
    );
  },
  SET_ERRORS: (state, errors) => state.errors = errors,
};
export default { state, actions, mutations };
